/*
 *  选择知识库
 */
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import knowledgeChoiceModalStore from './store';
import { SVGPureIcon } from '@/ui';
import AppCheckBox from '@/ui/checkbox';
import knowledgeChoiceStore from '@/components/knowledge-choice/store';

const FileList = observer(({ list, className }) => {
  useEffect(() => {
    return () => {
      knowledgeChoiceModalStore.handleCheck();
    }
  }, []);

  const store = knowledgeChoiceModalStore;
  return (
    <div className={['', className]}>
      {list.map(item => {
        const checked = store.checkedList.some(_item => _item.folder_id == item.folder_id);
        return (
          <div
            onClick={evt => {
              store.handleCheck(item);
            }}
            key={item.folder_id}
            className={[
              'h-36px pr-8px pl-8px flex items-center mb-4px rounded-8px hover:bg-[rgba(0,0,0,0.03)]',
              'cursor-pointer',
            ]}
          >
            <AppCheckBox
              checked={checked}
              className={[
                '!size-16px ml-auto flex-shrink-0 mr-8px',
              ]}
              isRadio
            />
            <div
              className={[
                'w-0 flex-grow text-14px text-black truncate h-36px leading-36px',
              ]}
            >
              {item.name}
            </div>
          </div>
        );
      })}
    </div>
  );
});

const TitleItem = ({ item, type, hasChild = false }) => {
  const [showList, setShowList] = useState(false);

  return (
    <>
      <div
        onClick={async evt => {
          setShowList(!showList);
          if (hasChild) {
            if (showList) {
              setShowList(false);
            } else {
              setShowList(true);
            }
          } else {
            knowledgeChoiceModalStore.toggleFold(type);
          }
        }}
        className={`w-full mb-4px px-8px flex items-center h-32px text-14px text-black text-opacity-50 cursor-pointer rounded-8px hover:bg-[rgba(0,0,0,0.03)] ${item.is_default ? "hidden" : ""}`}
      >
        {item.name}
        <SVGPureIcon
          name={'knledge_arrow'}
          className={[
            'w-12px h-8px ml-auto transform transition-all',
            showList ? 'rotate-180' : '',
          ]}
        />
      </div>
    </>
  );
};

const KnowledgeChoice = observer(props => {
  const { onClose, onSucc } = props;
  const store = knowledgeChoiceModalStore;

  useEffect(() => {
    knowledgeChoiceStore.loadList(0);
    knowledgeChoiceStore.loadList(1);
  }, []);

  return (
    <div className="w-480px max-h-full select-none">
      <div className="flex items-center mt-10px mb-16px">
        <div className="text-24px leading-34px text-black font-bold">
          选择知识库
        </div>
      </div>
      <div className="h-414px overflow-y-scroll nw-scrollbar-thin mt-16px mb-6px">
        {store.list_default?.length > 0 ? (
          <>
            {store.list_default.map(item => {
              return (
                <FileList key={item.folder_id} className={['']} list={[item]} />
              );
            })}
          </>
        ) : null}
        {store.list_create?.length > 0 ? (
          <>
            <TitleItem
              item={{ name: '我创建的专业知识库' }}
              type="fold_create"
            />
            <div className={['', store.fold_create ? 'hidden' : '']}>
              <FileList className={['']} list={store.list_create
                .filter(item => item.is_default != 1)} />
            </div>
          </>
        ) : null}
        {store.list_share?.length > 0 ? (
          <>
            <TitleItem
              item={{ name: '我加入的分享知识库' }}
              type="fold_share"
            />
            <div className={['', store.fold_share ? 'hidden' : '']}>
              <FileList className={['']} list={store.list_share
                .filter(item => item.is_default != 1)} />
            </div>
          </>
        ) : null}
      </div>
      <div className="flex justify-end">
        <div
          onClick={evt => {
            onClose();
          }}
          className={[
            'w-96px h-40px',
            'vh-center rounded-12px bg-black bg-opacity-6 hover:bg-opacity-9 cursor-pointer',
            'text-black text-16px font-bold mr-12px',
          ]}
        >
          取消
        </div>
        <div
          onClick={evt => {
            onClose();
            onSucc && onSucc(store.checkedList);
          }}
          className={[
            'w-96px h-40px',
            'vh-center rounded-12px bg-black',
            'text-white text-16px font-bold',
            store.checkedList.length
              ? 'hover:bg-[#333] cursor-pointer'
              : 'bg-opacity-30',
          ]}
        >
          确定
        </div>
      </div>
    </div>
  );
});

export default KnowledgeChoice;
